import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, PatternValidator, FormArray } from '@angular/forms';
import { ProductService } from '../../services/productservice';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'contactus',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  providers: [MessageService],
})
export class ContactComponent implements OnInit {
  public contactDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  public basicDetailsForm: any;
  public captchaResponse: any;
  public isCaptcha: boolean;
  recaptcha: any;
  images: any = [];
  activeIndex: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  constructor(
    public productService: ProductService,
    public fb: FormBuilder,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}
  ngOnInit(): void {
    // this.recaptcha = (window as any).grecaptcha;
    this.loadRecaptcha();
    this.getAboutUsDetails();
    this.basicDetailsForm = this.fb.group({
      name: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      subject: new FormControl(null, [Validators.required]),
      message: new FormControl(null, [Validators.required]),
      // captcha: new FormControl(null, [Validators.required]),
      authorization: new FormControl(null, [Validators.required]),
    });
  }
  getAboutUsDetails() {
    this.productService.getContactDetails().subscribe((data) => {
      this.contactDetails = data;
      this.images.push(this.contactDetails.bannerImage);
    });
  }

  saveContactDetails() {
    if (this.basicDetailsForm.valid && this.captchaResponse) {
      this.productService.saveContacts(this.basicDetailsForm.value).subscribe((data) => {
        if (data) {
          this.messageService.add({
            key: 'contact',
            severity: 'success',
            summary: this.translate.instant('Success'),
            detail: this.translate.instant('ContactUs-Success'),
          });
          setTimeout(() => {
            this.basicDetailsForm.reset();
          }, 2000);
        }
      });
    }
  }

  showResponse(event: any) {
    this.captchaResponse = event.response;
    if (this.captchaResponse != undefined || this.captchaResponse) {
      this.isCaptcha = true;
    }
  }
  resetCaptchaResponse() {
    this.recaptcha.reset();
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  private loadRecaptcha(): void {
    if ((window as any).grecaptcha) {
      this.recaptcha = (window as any).grecaptcha;
      return;
    }

    const existingScript = document.getElementById('recaptcha-api');

    if (existingScript) {
      existingScript.addEventListener('load', () => {
        this.recaptcha = (window as any).grecaptcha;
      });
      return;
    }

    const script = document.createElement('script');
    script.id = 'recaptcha-api';
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;

    script.onload = () => {
      this.recaptcha = (window as any).grecaptcha;
    };

    document.body.appendChild(script);
  }
}
